/**
 * We use this PortalContext here as a form of dependency injection
 * this allows developers to mount larger component trees with portals in them
 * to provide context to the Portal component to render the content inline rather
 * than creating a div and appending that to the end of the document.
 *
 * e.g.
 * mount(
 *   <PortalContext.Provider value={{ inTestEnvironment: true, createContainer, removeContainer }}>
 *     <Component />
 *   </PortalContext.Provider>
 * )
 */

import {createContext} from 'react';

export function defaultCreateContainer() {
  return document.body.appendChild(document.createElement('div'));
}

export function defaultRemoveContainer(node) {
  if (document?.body?.contains(node)) {
    document.body.removeChild(node);
  }
}

const PortalContext = createContext({
  inTestEnvironment: false,
  createContainer: defaultCreateContainer,
  removeContainer: defaultRemoveContainer,
});

export default PortalContext;
